(function ($) {
    $.fn.colorfulCard = function (paramsArray) {
        // Verifica si paramsArray es un array
        if (!Array.isArray(paramsArray)) {
            console.error('Se esperaba un array como parámetro.');
            return this;
        }

        // Función para obtener un color aleatorio
        function getRandomColor() {
            const colors = ['#6CCA99', '#7589EF', '#FFFFCC', '#ECCE3B', '#68BFE5', '#EC6262', '#F1A852', '#A7CC6C', '#EC75BC'];
            return colors[Math.floor(Math.random() * colors.length)];
        }

        this.addClass("d-flex flex-wrap gap-3 mt-3");

        // Limpiar el contenido existente
        this.empty();

        // Iterar sobre el array y crear una tarjeta para cada elemento
        paramsArray.forEach((params) => {
            // Valores predeterminados para cada tarjeta
            const defaults = {
                text: 'Tarjeta Colorida',
                count: 1,
                backgroundColor: null // Color de fondo de la tarjeta
            };

            const options = $.extend({}, defaults, params);

            // Crear el HTML de la tarjeta
            const cardHtml = `
                <div class="card-container" ${options.backgroundColor ? `style="background-color: ${options.backgroundColor};"` : ''}>
                    <span class="card-title">${options.text}</span>
                    <span class="card-count">${options.count}</span>
                </div>
            `;

            // Añadir la tarjeta al contenedor principal
            this.append(cardHtml);

            // Si no se especificó un color, asignar uno aleatorio
            if (!options.backgroundColor) {
                const $lastCard = this.find('.card-container').last();
                $lastCard.css('background-color', getRandomColor());
            }
        });

        return this; // Permite el encadenamiento
    };
})(jQuery);